import { Link, useLocation, useNavigate } from "react-router-dom";
import { LogOut, LayoutList, User, Calendar as CalIcon, RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { ADMIN } from "@/constants/testIds";

export default function AdminNav({ meName, onRefresh }) {
  const loc = useLocation();
  const nav = useNavigate();
  const tabs = [
    { to: "/admin", label: "Appointments", icon: LayoutList, testId: "admin-tab-appointments" },
    { to: "/admin/availability", label: "Availability", icon: CalIcon, testId: "admin-tab-availability" },
    { to: "/admin/profile", label: "Profile", icon: User, testId: "admin-tab-profile" },
  ];

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("admin_token");
    nav("/admin/login");
  };

  return (
    <header
      className="border-b hairline sticky top-0 z-40"
      style={{ background: "rgba(249,248,246,0.9)", backdropFilter: "blur(12px)" }}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-4 flex flex-wrap items-center justify-between gap-4">
        <div>
          <div className="mono-eyebrow">§ Admin</div>
          <div className="serif text-xl mt-1" style={{ letterSpacing: "-0.015em" }}>{meName || "Mr. Aggarwal"}</div>
        </div>
        <div className="flex items-center gap-1">
          {tabs.map((t) => {
            const active = loc.pathname === t.to;
            const Icon = t.icon;
            return (
              <Link
                key={t.to}
                to={t.to}
                data-testid={t.testId}
                className="inline-flex items-center gap-2 px-4 py-2 text-xs tracking-wider uppercase border"
                style={{
                  borderColor: active ? "var(--ink)" : "transparent",
                  background: active ? "var(--ink)" : "transparent",
                  color: active ? "var(--cream)" : "var(--ink)",
                }}
              >
                <Icon size={14} strokeWidth={1.4} /> {t.label}
              </Link>
            );
          })}
        </div>
        <div className="flex items-center gap-3">
          {onRefresh && (
            <button onClick={onRefresh} className="btn-ghost !py-2 !px-4 !text-[11px]" data-testid="refresh-btn">
              <RefreshCw size={14} /> Refresh
            </button>
          )}
          <button onClick={logout} data-testid={ADMIN.logoutBtn} className="btn-terra !py-2 !px-4 !text-[11px]">
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
